import StandTypologyModel        from '@models/website/StandTypologyModel';
import StandStatusModel          from '@models/website/StandStatusModel';
import ExhibitorModel            from '@models/website/ExhibitorModel';
import WebsiteEntertainmentModel from '@models/website/WebsiteEntertainmentModel';
import doc                       from '@widesk-core/decorators/doc';
import WebsiteServiceModel       from '@/models/WebsiteServiceModel';
import Blamable                  from '@/models/traits/Blamable';
import { Addable }               from '@widesk-core/decorators/addable';
import { Editable }              from '@widesk-core/decorators/editable';
import { Deletable }             from '@widesk-core/decorators/deletable';
import { Timestampable }         from '@widesk-core/decorators/timestampable';

@doc.path('/stands/{?id}')
@doc.addable
@doc.editable
@doc.deletable
@doc.timestampable
abstract class AbstractStandModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'partial': string;
		'existsInContentToPublish': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'standStatusHistories.createdAt[before]': string | Date;
		'standStatusHistories.createdAt[strictly_before]': string | Date;
		'standStatusHistories.createdAt[after]': string | Date;
		'standStatusHistories.createdAt[strictly_after]': string | Date;
		'standStatus': string;
		'standTypology': id;
		'standTaxonomies.taxonomy': id;
		'exhibitor': id;
		'exhibitor.entityUrn': Urn;
		'websiteEntertainment': id;
		'hall': id;
		'slot': string;
		'slug': string;
		'reference': string;
		'standStatusHistories.standStatus': string;
		'standPages.standPageValidationStatus': string;
		'standTags.tag': id;
		'search': string;
	};

	declare private _tsSorts: {
		daisukiCount: string;
		id: string;
		hall: string;
		slot: string;
		title: string;
		createdAt: string;
		updatedAt: string;
		'standPages.createdAt': string;
		'standPages.updatedAt': string;
	};

	@doc.model(StandTypologyModel) declare standTypology: StandTypologyModel;
	@doc.model(StandStatusModel) declare standStatus: StandStatusModel;
	@doc.model(ExhibitorModel) declare exhibitor: ExhibitorModel;
	@doc.model(WebsiteEntertainmentModel)
	declare websiteEntertainment: WebsiteEntertainmentModel;
	@doc.string declare title: string;
	@doc.string declare slug: string;
	@doc.string declare hall: string;
	@doc.string declare slot: string;
	@doc.string declare reference: string;
}

interface AbstractStandModel
	extends Addable,
		Editable,
		Deletable,
		Timestampable {}

export default AbstractStandModel;
